import { PriceCard, PriceCardProps } from "./PriceCard";

export function PriceCardContainer(props: { title?: string; prices?: PriceCardProps[] }) {
  const { prices, title } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "24px 36px", gap: 50 }}>
      <div style={{ color: "#95A3B5", fontSize: 18 }}>{title}</div>
      <div style={{ display: "flex", gap: 16, overflow: "auto", whiteSpace: "nowrap" }}>
        {prices && prices.map((price , index) => <PriceCard key={index} {...price} />)}
      </div>
    </div>
  );
}
